import { createI18n, type DefaultLocaleMessageSchema } from 'vue-i18n';
import enus from './en-us';
import esus from './es-us';
import enca from './en-ca';
import frca from './fr-ca';
import { enCA, enUS, esUS, frCA } from '@primerica/onex-ui-lib';
import type { UILocale } from '@/shared';
import mypritranslations from './mypriTranslations';

const usNumberFormat = {
  currency: {
    style: 'currency' as const,
    currency: 'USD',
  },
  currencyNoCents: {
    style: 'currency' as const,
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
};

const caNumberFormat = {
  currency: {
    style: 'currency' as const,
    currency: 'CAD',
  },
  currencyNoCents: {
    style: 'currency' as const,
    currency: 'CAD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  },
};

const numberFormats = {
  'en-US': usNumberFormat,
  'es-US': usNumberFormat,
  'en-CA': caNumberFormat,
  'fr-CA': caNumberFormat,
};

const options = {
  messages: {
    'en-US': { ...enUS, ...enus, ...mypritranslations.en_US },
    'es-US': { ...esUS, ...esus, ...mypritranslations.es_US },
    'en-CA': { ...enCA, ...enca, ...mypritranslations.en_CA },
    'fr-CA': { ...frCA, ...frca, ...mypritranslations.fr_CA },
  },
  locale: 'en-US',
  fallbackLocale: 'en-US',
  numberFormats,
  legacy: true,
};
export const i18n = createI18n<
  [DefaultLocaleMessageSchema],
  UILocale.EN_US | UILocale.ES_US | UILocale.EN_CA | UILocale.FR_CA,
  true
>(options);

export const $t = i18n.global.t;
